/**
 * @module app.um
 */

import { autoinject } from "aurelia-framework";
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class SaveDiagnosis extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object protected diagnosis: UM.AuthDiagnosis = { id: null };

    @bindable.objectNull()
    protected auth: UM.Auth | null = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}

